import { render } from "./popBg.vue?vue&type=template&id=5ab86c18&scoped=true"
import script from "./popBg.vue?vue&type=script&lang=js"
export * from "./popBg.vue?vue&type=script&lang=js"

import "./popBg.vue?vue&type=style&index=0&id=5ab86c18&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5ab86c18"

export default script